
export default function IndustryOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-[#8B1538] font-bold text-sm uppercase tracking-wider">
              Industry Overview
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mt-3 mb-8 text-gray-900 font-['Montserrat']">
              South Africa: Africa&apos;s Business Gateway
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6 text-[15px]">
              South Africa has become the entrance and comfort place for
              international companies coming to do business in Africa since the
              end of the apartheid era. The country has been a launching platform
              for international firms expanding into Africa, be it Southern or
              over Sahara region and West Africa.
            </p>
            <p className="text-gray-700 leading-relaxed text-[15px]">
              The infrastructure has made this country more accessible and enabled
              it to be able to conduct business with the global community. Not only
              does South Africa have good infrastructure, but the country is also
              rich in minerals that attract international markets.
            </p>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/40ba121ce945bc839a99e277541a33c0.jpg"
                alt="South Africa business infrastructure"
                className="w-full h-[400px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#8B1538] text-white p-6 rounded-lg shadow-lg max-w-[260px]">
              <div className="text-3xl font-bold font-['Montserrat']">Since 1994</div>
              <div className="text-sm text-white/90 mt-1">
                A launching platform for international firms expanding into Africa
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
